import { useMutation } from "@tanstack/vue-query";
import Meeting from "@/services/meeting";
import { RegisterMeeting } from "@/dtos/Meeting.dto";

/**
 * Composable for generating a meeting link
 */
export function useGenerateMeetingLink() {
  return useMutation({
    mutationFn: async (meeting: RegisterMeeting) => {
      const result = await Meeting.generateMeetingLink(meeting);
      if (!result.data.status) {
        throw new Error(result.data.msg || "Failed to generate meeting link");
      }
      return result.data.data;
    },
  });
}
